import { HttpClient } from '@angular/common/http';
import { Validator } from '@libs/utilities/validator';
import { Injectable } from '@angular/core';
import { Observable, defer, map } from 'rxjs';
import { SecureHttp } from '@domains/security/frontend';
import { IAgentWorkflowResult, AgentWorkflowResultSchema, FLYING_AGENT_EXPLAIN_ROUTE, FlyingAgentExplainRequestSchema, IFlyingAgentExplainRequest, IFlyingAgentExplainStreamEvent } from '@apps/flying/shared';

import { AuthSecurityService } from '../../../services/shared/auth/auth-security/auth-security.service';
import { ENVIRONMENT } from '../../../../environments';


@Injectable()
export class AgentRequest {

	constructor(
		private secureHttp			: SecureHttp,
		private authSecurityService	: AuthSecurityService,
		private http: HttpClient
	) {}


	explainFunction(body: IFlyingAgentExplainRequest): Observable<IFlyingAgentExplainStreamEvent> {
		return defer(() => this.secureHttp.post(FLYING_AGENT_EXPLAIN_ROUTE)
			.setServerUrl(ENVIRONMENT.BACKEND.SERVER_URL)
			.setSecurity({
				timeToken	: true,
				encryption	: { request: false, response: false }
			})
			.setAuthToken(this.authSecurityService.getBearerToken())
			.setBody<IFlyingAgentExplainRequest>(body, FlyingAgentExplainRequestSchema)
			.streamSse<IFlyingAgentExplainStreamEvent>());
	}
	completeAction(body: IAgentWorkflowResult): Observable<unknown> {
		// This Express endpoint uses the legacy encryption interceptor. SecureHttp bypasses it.
		return defer(() => {
			if (!Validator.Schema.isValid(body, AgentWorkflowResultSchema)) throw new Error('Invalid workflow result.');
			return this.http.post<{ accepted?: boolean }>(`${ENVIRONMENT.BACKEND.SERVER_URL.replace(/\/$/, '')}/agent/action-result`, body);
		}).pipe(map((response) => {
			// The legacy interceptor can emit HTTP errors as values; require an explicit acknowledgement.
			if (response?.accepted !== true) throw new Error('The workflow result was not accepted.');
			return response;
		}));
	}

}
